let currentContext = null;

export const setDiscoverChatContext = (data) => {
    currentContext = data;
};

export const clearDiscoverChatContext = () => {
    currentContext = null;
};

export const getDiscoverChatContext = () => currentContext;
